import React, { useState, useEffect } from 'react';
import { Box, useTheme } from '@mui/material';

const ReadingProgressBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const theme = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (totalHeight > 0) {
        const currentProgress = (window.scrollY / totalHeight) * 100;
        setScrollProgress(Math.min(100, Math.max(0, currentProgress)));
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (scrollProgress <= 1) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3.5px',
        zIndex: 9999,
        backgroundColor: 'transparent',
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: `${scrollProgress}%`,
          background: theme.palette.mode === 'dark'
            ? 'linear-gradient(90deg, #38bdf8 0%, #e5a93c 50%, #34d399 100%)'
            : 'linear-gradient(90deg, #0284c7 0%, #b8860b 50%, #059669 100%)',
          boxShadow: theme.palette.mode === 'dark'
            ? '0 0 10px rgba(229, 169, 60, 0.6)'
            : '0 0 8px rgba(184, 134, 11, 0.4)',
          transition: 'width 60ms ease-out',
        }}
      />
    </Box>
  );
};

export default ReadingProgressBar;
